<template>
  <b-col>
    <b-row>
      <b-col cols="12" class="mx-auto mt-4">
        <table class="w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2">Directors</span>
            </th>
          </tr>
          </thead>
          <tbody>
            <LegalPersonsDetails class="p-1" :persons="getCompanyDirectors.data.content"/>
          </tbody>
        </table>
      </b-col>
    </b-row>



      <b-row v-if="getForm1Details">
          <b-col cols="12" class="mx-auto mt-4">
              <table class="w-full leading-normal text-gray"
                     style="border: solid 1px #dedede;">
                  <thead class="bg-gray-pale" >
                  <tr>
                      <th colspan="12" class="py-2">
                          <span class="px-2">Nominee Director</span>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <LegalPersonsDetails class="p-1" :persons="[{...getForm1Details.data.nomineeDirector}]"/>
                  </tbody>
              </table>
          </b-col>
      </b-row>

      <b-row v-if="getForm1Details">
          <b-col cols="12" class="mx-auto mt-4">
              <table class="w-full leading-normal text-gray"
                     style="border: solid 1px #dedede;">
                  <thead class="bg-gray-pale" >
                  <tr>
                      <th colspan="12" class="py-2">
                          <span class="px-2">Alternate Director</span>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <LegalPersonsDetails class="p-1" :persons="[{...getForm1Details.data.alternativeNomineeDirector}]"/>
                  </tbody>
              </table>
          </b-col>
      </b-row>
  </b-col>
</template>

<script>
import {mapGetters} from "vuex";
import LegalPersonsDetails from "@/views/home/services/registry/business/files/tabs/company_data/LegalPersonsDetails";

export default {
  name: "CompanyDirectors",
  components: {LegalPersonsDetails},
  computed:{
    ...mapGetters(["getCompanyDirectors", "getCompanySecretary","getForm1Details"])
  }
}
</script>

<style scoped>

</style>